import { checkSearchObject } from "app/common/LocalFunction";
import { StoreConfig } from "app/common/Model/StoreConfig";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  deleteStoreConfig,
  getStoreConfigById,
  getSyncStore,
  pagingStoreConfig,
  saveOrUpdateStoreConfig,
} from "app/services/StoreConfigService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { getListDrugInventoryFromStore } from "app/services/StoreRequestService";
import { getDrugSyncInventory } from "app/services/DrugService";

export default class StoreConfigStore {
  listAllStoreConfig = [];
  searchStoreConfig = new SearchObject();
  pageStoreConfig = null;
  selectedStoreConfig = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteStoreConfig = false;
  recentlyUpdated = false;
  listStoreConfigCode = {};
  openSyncStore = null;
  openDrugSyncInventory = null;

  //value for choosing store popup related to department 
  listStoreConfig = [];
  storeConfigIdSet = null;
  //

  constructor() {
    makeAutoObservable(this);
  }


  handleOpenSyncStore = () => {
    this.openSyncStore = true
  }

  handleCloseSyncStore = () => {
    this.openSyncStore = false
  }
  handleOpenDrugSyncInventory = () => {
    this.openDrugSyncInventory = true
  }

  handleCloseDrugSyncInventory = () => {
    this.openDrugSyncInventory = false
  }

  handleSaveDrugSyncInventory = (data, { setSubmitting }) => {
    getDrugSyncInventory(data).then(() => {
      this.openSyncStore = false;
      toast.success("Lấy tồn kho thành công")
      this.pagingStoreConfig()
    }).catch((err) => {
      toast.error("Lấy tồn kho thất bại")
    }).finally(() => {
      setSubmitting(false)
    })
  }
  handleSaveSyncStore = (data, { setSubmitting }) => {
    getSyncStore(data).then(() => {
      this.openSyncStore = false;
      toast.success("Đồng bộ kho thành công")
      this.pagingStoreConfig()
    }).catch((err) => {
      toast.error("Đồng bộ kho thất bại")
    }).finally(() => {
      setSubmitting(false)
    })
  }

  // handleGetListDrugInventoryFromStore = () => {
  //   getListDrugInventoryFromStore(this.listAllStoreConfig)
  //     .then(({ data }) => {
  //       toast.success("Lấy tồn kho thành công!");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       toast.error("Lấy dữ liệu có lỗi");
  //     });
  // }

  getAllStoreConfig = () => {
    if (!this.listAllStoreConfig?.length || this.recentlyUpdated) {
      return pagingStoreConfig({
        pageIndex: 1,
        pageSize: 1000000,
      })
        .then(({ data }) => {
          this.listAllStoreConfig = data.content.map(item => item?.code)
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    }
  };

  pagingStoreConfig = async () => {
    return await pagingStoreConfig(this.searchStoreConfig)
      .then(({ data }) => {
        this.pageStoreConfig = data;
        this.listStoreConfigCode = data.content.map(item => item?.code)
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchStoreConfig) => {
    this.searchStoreConfig = checkSearchObject(
      this.searchStoreConfig,
      searchStoreConfig
    );
    this.pagingStoreConfig();
  };

  handleOpenFormCreateOrEdit = async (storeId) => {
    if (Boolean(storeId)) {
      try {
        const { data } = await getStoreConfigById(storeId);
        if (data) {
          this.selectedStoreConfig = data;
          this.openFormCreateOrEdit = true;
        }
      } catch {
        toast.error("Lấy dữ liệu có lỗi!");
      }
    } else {
      this.selectedStoreConfig = new StoreConfig();
      this.openFormCreateOrEdit = true;
    }
  };

  saveStoreConfig = async (store, { setSubmitting }) => {
    try {
      const { data } = await saveOrUpdateStoreConfig(store);
      if (data) {
        this.selectedStoreConfig = null;
        this.pagingStoreConfig();
        this.handleClosePopup();
        this.recentlyUpdated = true;

        toast.success("Lưu cơ sở thành công!");
      }
    } catch {
      toast.error("Lưu cơ sở thất bại!");
    } finally {
      setSubmitting(false);
    }
  };

  handleConfirmDeleteStoreConfig = async () => {
    try {
      await deleteStoreConfig(this.selectedStoreConfig?.id);
      if (
        this.searchStoreConfig?.pageIndex > 1 &&
        this.pageStoreConfig?.content?.length === 1
      ) {
        this.searchStoreConfig.pageIndex -= 1;
      }
      this.pagingStoreConfig();
      this.recentlyUpdated = true;
      this.handleClosePopup();

      toast.success("Xóa cấu hình kho thành công!");
    } catch (error) {
      toast.error("Xóa cấu hình kho thất bại!");
    }
  };

  handleDeleteStoreConfig = (storeId) => {
    this.selectedStoreConfig = { id: storeId ?? "" };
    this.openConfirmDeleteStoreConfig = true;
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteStoreConfig = false;
  };


  // func for choosing store popup related to department
  isValidStore = store => {
    if (store && (store?.id || store?.storeConfig?.id)) return true;
    console.error("Invalid manipulated element");
    return false;
  };

  addStore = store => {
    if (!this.isValidStore(store)) return;

    const storeId = store?.storeConfig?.id || store?.id;

    // Nếu đã có rồi thì bỏ qua
    if (this.storeIdSet.has(storeId)) return;

    // Nếu là storeConfig gốc (từ API)
    const item = store?.storeConfig
      ? store
      : {
        id: null,
        storeConfig: {
          id: store.id,
          code: store.code,
          name: store.name,
        },
        //isDefault: false,
      };

    this.listStore.push(item);
    this.storeIdSet.add(storeId);
  };

  initializeListStore = stores => {
    this.storeIdSet = new Set();
    this.listStore = [];
    if (stores && stores.length > 0) {
      for (let i = 0; i < stores.length; i++) {
        this.addStore(stores[i]);
      }
    }
  };

  removeStore = store => {
    if (!this.isValidStore(store)) return;

    const storeId = store?.storeConfig?.id || store?.id;

    if (this.storeIdSet.has(storeId)) {
      this.storeIdSet.delete(storeId);
      // Xóa phần tử khỏi listStore
      this.listStore = this.listStore.filter(
        s => (s?.storeConfig?.id || s?.id) !== storeId
      );
    } else {
      console.error("Element not exist");
    }
  };

  isExist = store => {
    if (!this.isValidStore(store)) return false;
    const storeId = store?.storeConfig?.id || store?.id;
    return this.storeIdSet.has(storeId);
  };

  getStoreIdSet = () => {
    return this.storeIdSet;
  };

  getListStore = () => {
    const bufferIdSet = new Set();
    const data = [];

    if (this.listStore && this.listStore.length > 0) {
      for (let i = 0; i < this.listStore.length; i++) {
        const store = this.listStore[i];
        const storeId = store?.storeConfig?.id || store?.id;
        if (this.isExist(store) && !bufferIdSet.has(storeId)) {
          data.push(store);
          bufferIdSet.add(storeId);
        }
      }
    }

    this.listStore = data;
    return data;
  };


  resetStoreConfig = () => {
    this.searchStoreConfig = new SearchObject();
    this.pageStoreConfig = null;
    this.selectedStoreConfig = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteStoreConfig = false;
  };
}
